import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Productcard from '../components/productcard'
import Productfilters from '../components/productfilters'

import {
  Card,
  Icon,
  Image,
  Button,
  Label,
  List,
  Divider,
  Grid,
  Header,
  Statistic,
  Segment,
  Breadcrumb,
} from 'semantic-ui-react'

class CustomerPage extends Component {
  render() {
    const { name, product, id, website } = this.props.data.contentfulCustomer
    return (
      <div style={{ maxWidth: 1260, margin: '0 auto' }}>
        <Helmet>
          <title>The growth stack used by {name}| Find Growth Tools</title>
          <meta
            name="description"
            content={`Discover the growth tools used by ${name} in 2019, with features, pricing, customers, integrations and more.`}
          />
        </Helmet>
        <Segment basic>
          <Breadcrumb>
            <Breadcrumb.Section>
              <Link to="/Customers" style={{ color: '#dcddde' }}>
                <Icon name="angle left" />All customers
              </Link>
            </Breadcrumb.Section>
          </Breadcrumb>
        </Segment>

        <h1
          style={{
            fontSize: '1.5rem',
            color: '#fff',
          }}
        >
          Used by
          <span style={{ fontSize: '3.25rem' }}> {name}</span>
        </h1>

        {website ? (
          <Segment compact>
            <List>
              <List.Item>
                <List.Icon name="linkify" />
                <List.Content>
                  <a href={website} target="_blank">
                    {website}
                  </a>
                </List.Content>
              </List.Item>
            </List>
          </Segment>
        ) : (
          <span />
        )}

        <br />

        <div style={{ maxWidth: 760, margin: '0 auto' }}>
          <Segment basic>
            <p
              style={{ fontSize: '1.25em', color: '#fff', textAlign: 'center' }}
            >
              {name} are using the following tools in their growth marketing
              tech stack:
            </p>
          </Segment>
        </div>
        <br />

        {/* <Productfilters /> */}

        <br />
        <div>
          <Grid textAlign="center">
            {product ? (
              product.map(product => (
                <div>
                  <Productcard node={product} />
                </div>
              ))
            ) : (
              <span>Nothing yet! Check back soon :)</span>
            )}
          </Grid>
          <br />
        </div>
      </div>
    )
  }
}

CustomerPage.propTypes = {
  data: PropTypes.object.isRequired,
}

export default CustomerPage

export const pageQuery = graphql`
  query customerPageQuery($slug: String!) {
    contentfulCustomer(slug: { eq: $slug }) {
      name
      slug
      id
      website
      product {
        id
        slug
        name
        website
        primaryCategories {
          id
          name
          slug
        }
        subCategories {
          id
          name
        }
        growthLever {
          id
          name
        }
        customerSector {
          id
          name
        }
        customerBudget {
          id
          name
        }
        screenshots {
          id
          title
          resolutions(width: 265) {
            ...GatsbyContentfulResolutions
          }
          file {
            url
          }
        }
        shortDescription
        integratesWith {
          id
          name
        }
        customersList {
          name
          id
        }
        freeTrialAvailable
        developerRequired
        freePlan
        startingPrice
        pricingNote
        createdAt(formatString: "MMMM Do, YYYY")
        updatedAt(formatString: "MMMM Do, YYYY")
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/customer-page.js